import classNames from "classnames";
import React from "react";
import styles from "./Range.module.scss";
export function Range(_a) {
    var _b;
    var value = _a.value, max = _a.max, step = _a.step, onChange = _a.onChange, disabled = _a.disabled;
    return (React.createElement("span", { className: styles.range },
        React.createElement("input", { type: "range", value: value, max: max, step: step, className: classNames((_b = {},
                _b[styles.zero] = value === 0,
                _b[styles.disabled] = disabled,
                _b)), onChange: function (e) { return onChange(e.target.valueAsNumber); }, style: { "--bar-progress": "".concat((value / max) * 100, "%") }, disabled: disabled })));
}
